import { type Props } from '../../Form/TextInput/TextInput';

export function getInputType(
  { type, inputProps }: Pick<Props, 'type' | 'inputProps'>,
  maskedPasswordInput: boolean
) {
  const inputType = type || inputProps?.type;

  if (inputType === 'password') {
    // if `maskedPasswordInput` is true, return 'password' type, otherwise return 'text' type
    return maskedPasswordInput ? inputType : 'text';
  }

  return inputType || 'text';
}
